// Hook do pobierania listy procesów

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';

export interface IProcessItem {
  id: number;
  name: string;
  type: string;
  status: string;
  createdAt: string | null;
}

export interface IGetProcessesParams extends IPaginationRequest {
  search?: string;
  status?: string;
  type?: string;
}

interface IApiProcessItem {
  id: number;
  name: string;
  type: string;
  status: string;
  created_at: string | null;
}

interface IApiResponse {
  page?: number;
  total_count: number;
  total_pages: number;
  items: IApiProcessItem[];
}

type IResponse = IPaginationResponse<IProcessItem>;

// Transformacja danych z snake_case na camelCase
const transformProcessItem = (item: IApiProcessItem): IProcessItem => {
  // Bezpieczne mapowanie tylko wymaganych pól
  return {
    id: item?.id ?? 0,
    name: item?.name ?? '',
    type: item?.type ?? '',
    status: item?.status ?? 'inactive',
    createdAt: item?.created_at ?? null
  };
};

const getProcesses = async (params?: IGetProcessesParams): Promise<IResponse> => {
  try {
    // axios jest skonfigurowany z interceptorem, który zwraca response.data bezpośrednio
    // więc response jest już IApiResponse, nie AxiosResponse
    const response: IApiResponse = await axios.get<IApiResponse>('/dev-studio/process', { params }) as unknown as IApiResponse;
    
    if (!response || !response.items) {
      console.error('Missing data or items in response:', response);
      return {
        total_count: 0,
        total_pages: 0,
        items: []
      };
    }
    
    const transformed = {
      total_count: response.total_count ?? 0,
      total_pages: response.total_pages ?? 0,
      items: (response.items || []).map(transformProcessItem)
    };
    
    console.log('Transformed processes:', transformed.items);
    return transformed;
  } catch (error) {
    console.error('Error fetching processes:', error);
    return {
      total_count: 0,
      total_pages: 0,
      items: []
    };
  }
};

export const useGetProcesses = (
  params?: IGetProcessesParams,
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['processes', params], () => getProcesses(params), options);
